(() => {
  if (window.headerNavigationFitInitialized) return;
  window.headerNavigationFitInitialized = true;

  let cleanup = () => {};
  function setup() {
    cleanup();
    const header = document.querySelector('.section-header .header--middle-left:not(.drawer-menu)');
    const menu = header?.querySelector('.header__inline-menu');
    const logo = header?.querySelector('.header__heading') || header?.querySelector('.header__heading-link');
    const icons = header?.querySelector('.header__icons');
    const drawer = header?.querySelector('header-drawer');
    if (!header || !menu || !logo || !icons || !drawer) return;

    let frame;
    let active = true;
    const update = () => {
      if (!active) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (window.innerWidth < 990) {
          header.classList.remove('navigation-fit--desktop', 'navigation-fit--drawer');
          return;
        }
        header.classList.add('navigation-fit--measuring');
        const menuWidth = menu.getBoundingClientRect().width;
        header.classList.remove('navigation-fit--measuring');
        const style = getComputedStyle(header);
        const available = header.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        // Desktop uses two 2rem grid gaps. Allow a few pixels for rounding and focus outlines.
        const gap = parseFloat(getComputedStyle(document.documentElement).fontSize) * 2;
        const fits = logo.getBoundingClientRect().width + menuWidth + icons.getBoundingClientRect().width + gap * 2 + 8 <= available;
        if (fits && header.classList.contains('navigation-fit--drawer') && drawer.querySelector('details[open]') && typeof drawer.closeMenuDrawer === 'function') {
          drawer.closeMenuDrawer(new Event('resize'), drawer.querySelector('summary'));
        }
        header.classList.toggle('navigation-fit--desktop', fits);
        header.classList.toggle('navigation-fit--drawer', !fits);
      });
    };
    const observer = new ResizeObserver(update);
    [header, logo, icons].forEach((element) => observer.observe(element));
    const changes = new MutationObserver(update);
    changes.observe(menu, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', update);
    document.fonts?.ready.then(update);
    update();
    cleanup = () => {
      active = false;
      cancelAnimationFrame(frame);
      observer.disconnect();
      changes.disconnect();
      window.removeEventListener('resize', update);
    };
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
